// Single source of truth for support contact info.
// Same number is used for Call and WhatsApp (product decision, 2026-07-03);
// mirrors guest-app/src/lib/support.ts.
export const SUPPORT_PHONE_E164 = '+919645108642';

// Digits only, no "+" — the form wa.me expects.
const digits = SUPPORT_PHONE_E164.replace(/\D/g, '');

export const SUPPORT_TEL = `tel:${SUPPORT_PHONE_E164}`;
export const SUPPORT_WHATSAPP = `https://wa.me/${digits}`;
export const SUPPORT_PHONE_DISPLAY = '+91 96451 08642';
export const SUPPORT_EMAIL = 'support@pxtenergies.com';
